export const newsBrandReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_NEWS_BRAND_LIST_REQUEST": {
      return {
        ...state,
        loading: true,
        newsBrands: null,
      };
    }
    case "GET_NEWS_BRAND_LIST_SUCCESS": {
      return {
        ...state,
        loading: false,
        newsBrands: action.payload,
      };
    }
    case "GET_NEWS_BRAND_LIST_FAILED": {
      return {
        ...state,
        loading: false,
        newsBrands: action.payload,
      };
    }
    case "ADD_NEWS_BRAND_REQUEST": {
      return {
        ...state,
        loading: true,
        newsBrand: null,
      };
    }
    case "ADD_NEWS_BRAND_SUCCESS": {
      return {
        ...state,
        loading: false,
        newsBrand: action.payload,
      };
    }
    case "ADD_NEWS_BRAND_FAILED": {
      return {
        ...state,
        loading: false,
        newsBrand: action.payload,
      };
    }
    case "EDIT_NEWS_BRAND_REQUEST": {
      return {
        ...state,
        loading: true,
        newsBrand: null,
      };
    }
    case "EDIT_NEWS_BRAND_SUCCESS": {
      return {
        ...state,
        loading: false,
        newsBrand: action.payload,
      };
    }
    case "EDIT_NEWS_BRAND_FAILED": {
      return {
        ...state,
        loading: false,
        newsBrand: action.payload,
      };
    }
    case "VIEW_NEWS_BRAND_REQUEST": {
      return {
        ...state,
        loading: true,
        singleNewsBrand: null,
      };
    }
    case "VIEW_NEWS_BRAND_SUCCESS": {
      return {
        ...state,
        loading: false,
        singleNewsBrand: action.payload,
      };
    }
    case "VIEW_NEWS_BRAND_FAILED": {
      return {
        ...state,
        loading: false,
        singleNewsBrand: action.payload,
      };
    }
    case "DELETE_NEWS_BRAND_REQUEST": {
      return {
        ...state,
        loading: true,
        newsBrand: null,
      };
    }
    case "DELETE_NEWS_BRAND_SUCCESS": {
      return {
        ...state,
        loading: false,
        newsBrand: action.payload,
      };
    }
    case "DELETE_NEWS_BRAND_FAILED": {
      return {
        ...state,
        loading: false,
        newsBrand: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
